import { IconSvg } from '../../types'

export const DayIcon: IconSvg = (props) => {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" {...props}>
      <path
        d="M8 1.80609V2.4943M8 13.5057V14.1939M14.1939 8H13.5057M2.4943 8H1.80609M12.3798 12.3798L11.8931 11.8931M4.10688 4.10688L3.62024 3.62024M12.3798 3.62028L11.8932 4.10692M4.10692 11.8932L3.62028 12.3798M10.7528 8C10.7528 9.52036 9.52036 10.7528 8 10.7528C6.47964 10.7528 5.24715 9.52036 5.24715 8C5.24715 6.47964 6.47964 5.24715 8 5.24715C9.52036 5.24715 10.7528 6.47964 10.7528 8Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
